/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown>, pct: NonNullable<unknown> }} Plan_Build_Row_ActivationInputs */

const en_us2_plan_build_row_activation = /** @type {(inputs: Plan_Build_Row_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} ${i?.pct}%`)
};

const pt_br2_plan_build_row_activation = /** @type {(inputs: Plan_Build_Row_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} ${i?.pct}%`)
};

const es_419_plan_build_row_activation = /** @type {(inputs: Plan_Build_Row_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} ${i?.pct}%`)
};

const pt_pt2_plan_build_row_activation = /** @type {(inputs: Plan_Build_Row_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} ${i?.pct}%`)
};

const fr_fr2_plan_build_row_activation = /** @type {(inputs: Plan_Build_Row_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} ${i?.pct} %`)
};

const de_de2_plan_build_row_activation = /** @type {(inputs: Plan_Build_Row_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} ${i?.pct}%`)
};

const it_it2_plan_build_row_activation = /** @type {(inputs: Plan_Build_Row_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.muscle} ${i?.pct}%`)
};

/**
* | output |
* | --- |
* | "{muscle} {pct}%" |
*
* @param {Plan_Build_Row_ActivationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_row_activation = /** @type {((inputs: Plan_Build_Row_ActivationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Row_ActivationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_row_activation(inputs)
	if (locale === "es-419") return es_419_plan_build_row_activation(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_row_activation(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_row_activation(inputs)
	if (locale === "de-DE") return de_de2_plan_build_row_activation(inputs)
	if (locale === "it-IT") return it_it2_plan_build_row_activation(inputs)
	return en_us2_plan_build_row_activation(inputs)
});
export { plan_build_row_activation as "plan-build.row_activation" }